<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<empty-layout *ngIf="layout === 'empty'"></empty-layout>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Moonlight layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<moonlight-layout *ngIf="layout === 'moonlight'"></moonlight-layout>
